import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaCadranSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 0;

  .trima-chips-grid {
    display: flex;
    flex-wrap: wrap;
    gap: ${prem(8)};
    padding: ${prem(16)} ${prem(16)} ${prem(50)};
  }
`;

export const TrimaCadranFooter = styled.div<{ $active?: boolean }>`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--ion-background-color, #ffffff);
  border-top: 1px solid var(--ion-color-light, #e5e5e5);
  padding: ${prem(12)} ${prem(16)} ${prem(16)};

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    height: ${prem(48)};
    background: linear-gradient(to bottom, transparent, var(--ion-background-color, #ffffff));
    pointer-events: none;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${prem(8)};

  .trima-counter {
    font-size: ${prem(13)};
    font-weight: 600;
    color: ${({ $active }) =>
      $active ? 'var(--ion-text-color-primary)' : 'var(--ion-text-color-secondary)'};
    transition: color 150ms ease;
  }

  .trima-error {
    font-size: ${prem(12)};
    color: var(--ion-color-danger, #eb445a);
    text-align: center;
  }

  .trima-validate-row {
    width: 100%;
  }
`;
